import { ErrorTypes } from "@wix/form-validator";
import { brazilVatIdValidator, VatIDType, getVatIDType } from "./brazil-vat-id-validator.js";
import { israelVatIdValidator } from "./israel-vat-id-validator.js";
const validateVatID = ({
  value,
  target,
  externalData
}) => {
  if (!value) {
    return void 0;
  }
  const country = externalData?.country;
  if (country === "IL") {
    const isValid2 = israelVatIdValidator(value);
    if (!isValid2) {
      return {
        errorPath: target,
        errorType: ErrorTypes.FORMAT_ERROR,
        errorMessage: 'must match format "vat ID"',
        params: {
          format: "custom IL field validations"
        }
      };
    }
    return void 0;
  }
  const isValid = brazilVatIdValidator(value);
  if (!isValid) {
    return {
      errorPath: target,
      errorType: ErrorTypes.FORMAT_ERROR,
      errorMessage: 'must match format "vat ID"',
      params: {
        format: "custom BR field validations"
      }
    };
  }
  return void 0;
};
const getVatIDValue = (id, country) => {
  if (country === "IL") {
    return { id, type: VatIDType.UNSPECIFIED };
  }
  const vatType = getVatIDType(id);
  return { id, type: vatType };
};
export {
  getVatIDValue,
  validateVatID
};
//# sourceMappingURL=vat-id-validation.js.map
